"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.LightboxProvider = exports.useLightbox = void 0;
var jsx_runtime_1 = require("react/jsx-runtime");
var react_1 = __importStar(require("react"));
var react_dom_1 = __importDefault(require("react-dom"));
var Lightbox_1 = require("../../molecules/Lightbox");
// should not need to export this outside of this component
var Context = (0, react_1.createContext)({
    open: function () { },
    close: function () { },
});
/**
 * Hook for Lightbox provider state
 */
var useLightbox = function () { return (0, react_1.useContext)(Context); };
exports.useLightbox = useLightbox;
/**
 * State management for Lightbox Component
 */
exports.LightboxProvider = react_1.default.memo(function (_a) {
    var children = _a.children;
    var _b = (0, react_1.useState)([]), slides = _b[0], setSlides = _b[1];
    var _c = (0, react_1.useState)(0), currentSlide = _c[0], setCurrentSlide = _c[1];
    var _d = (0, react_1.useState)(false), open = _d[0], setOpen = _d[1];
    /**
     * Open lightbox with optional starting index
     */
    var handleOpen = (0, react_1.useCallback)(function (slidesArr, index) {
        if (index === void 0) { index = 0; }
        // make sure index is within bounds
        var safeIndex = index <= slidesArr.length - 1 ? index : 0;
        setOpen(true);
        setSlides(slidesArr);
        setCurrentSlide(safeIndex);
    }, [setOpen, setSlides, setCurrentSlide]);
    /**
     * Close lightbox
     */
    var handleClose = (0, react_1.useCallback)(function () {
        setOpen(false);
        setSlides([]);
        setCurrentSlide(0);
    }, [setOpen, setSlides, setCurrentSlide]);
    var Innards = (0, react_1.useMemo)(function () {
        return slides.length ? ((0, jsx_runtime_1.jsx)(Lightbox_1.Lightbox, { onClose: handleClose, open: open, slides: slides, startingSlide: currentSlide })) : null;
    }, [handleClose, slides, open, currentSlide]);
    var Portal = react_1.default.memo(function () { return react_dom_1.default.createPortal(Innards, document.body); });
    var providerValue = react_1.default.useMemo(function () { return ({
        open: handleOpen,
        close: handleClose,
    }); }, [handleOpen, handleClose]);
    return ((0, jsx_runtime_1.jsxs)(jsx_runtime_1.Fragment, { children: [(0, jsx_runtime_1.jsx)(Context.Provider, __assign({ value: providerValue }, { children: children })), (0, jsx_runtime_1.jsx)(Portal, {})] }));
});
